<div class="mt-4 mb-3">
  <div *ngIf="hasDates()">
    <p *ngFor="let data of results">
      <a *ngIf="data.assetTypeName == 'Editorial Calendar' || data.assetTypeName == 'Dates'"
        class="tittle1 font-weight-bold" rel="noopener noreferrer" (click)="onMedialinkClick(data.url)"
        style="display:block"> {{data.assetName}}.pdf</a>
    </p>
  </div>
  <div class="tittle1 font-weight-bold" *ngIf="!hasDates()">No Dates</div>
</div>